import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarked, faMotorcycle } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios'
import { MDBInput } from 'mdbreact';

const Domicilios = ({ UrlUbicaciones, clienteRegis, checkDomi, setCheckDomi }) => {

    const peticionTraeUbicaciones = async () => {

    }

    useEffect(() => {
        peticionTraeUbicaciones()
    }, [])

    const cambiaChecks = () => {
        setCheckDomi(!checkDomi)
    }


    return (
        <>
            <div className="domicilios">
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ flex: 2 }}>
                        <MDBInput
                            onClick={cambiaChecks}
                            checked={checkDomi}
                            style={{ marginTop: "15px", flex: 2 }}
                            type="checkbox"
                            id="domi"
                            disabled={!clienteRegis}
                        />
                    </div>
                    <div style={{ flex: 10 }}>
                        <label htmlFor='domi' style={{ marginTop: "15px" }} className="labelPasare"> ¿Deseas Envío?</label>
                    </div>
                </div>
            </div>
            {
                checkDomi ?
                    <div className="row domicilios">
                        <div className='col-md-12'>
                            <span>
                                <b>Nombres: </b>{clienteRegis?.nombres}
                            </span>
                            <br />
                            <span><b>Dirección:</b> {clienteRegis?.direccion}</span>
                            <br />
                            <span><b>Telefono:</b> {clienteRegis?.telefono}</span>
                        </div>

                    </div>
                    : null
            }
        </>
    )
}



export default Domicilios